import { Table } from '@mantine/core';
import { useMemo } from 'react';

import { botTypes } from '../../../types';

import { BodyRow } from './BodyRow';

import { InstPage, TgPage } from '@/features/pages';
import { Departments } from '@/types';

type PagesTableProps = {
  department: Departments;
  pages: botTypes.Page[];
  appPagesData: (TgPage | InstPage)[];
};

export const BotPagesTable = ({ department, pages, appPagesData }: PagesTableProps) => {
  const pagesMap = useMemo(() => new Map(appPagesData.map((p) => [p._id, p])), [appPagesData]);

  return (
    <Table stickyHeader striped highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Name</Table.Th>
          <Table.Th>Id</Table.Th>
          <Table.Th>Sub-department</Table.Th>
          <Table.Th>Linked pages</Table.Th>
          <Table.Th ta="center">Expert</Table.Th>
          <Table.Th ta="center">Mandatory manager select</Table.Th>
          <Table.Th style={{ whiteSpace: 'nowrap', width: 1 }}>Actions</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {pages.map((page) => (
          <BodyRow key={page._id} department={department} page={page} pagesMap={pagesMap} />
        ))}
      </Table.Tbody>
    </Table>
  );
};
